import ProductFilter from "./ProductFilter"

export default  ProductFilter;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/ProductFilter/index.js